<template>
    <div class="progress-container">
        <Spinner />
    </div>
</template>

<script>
export default {};
</script>

<style scoped>
.progress-container {
    min-height: 200px;
    height: 200px;

    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--primary);
}
</style>
